/* eslint-disable max-len */
export const SR_API_ERROR_ACTION_NOT_FOUND = 'SrApiErrorActionNotFound';
export const SR_API_ERROR_ACTION_PAYLOAD_VALIDATION_FAILED =
  'SrApiErrorActionPayloadValidationFailed';
export const SR_API_ERROR_NOT_ALLOWED = 'SrApiErrorNotAllowed';
export const SR_API_ERROR_NOT_FOUND = 'SrApiErrorNotFound';
export const SR_API_ERROR_INVALID_CREDENTIALS = 'SrApiErrorInvalidCredentials';
export const SR_API_ERROR_REQUEST_INVALID_RESPONSE = 'SrApiErrorRequestInvalidResponse';
export const SR_API_ERROR_REQUEST_FAILED = 'SrApiErrorRequestFailed';
export const SR_API_ERROR_REQUEST_NOT_HANDLED_OK = 'SrApiErrorRequestNotHandledOk';
export const SR_RENDERER_INVALID_RESPONSE_TYPE = 'SrRendererInvalidResponseType';
export const SR_ERROR_USER_ALREADY_EXISTS = 'SrErrorUserAlreadyExists';
export const SR_ERROR_LISTING_ALREADY_EXISTS = 'SrErrorListingAlreadyExists';

export const SR_ERROR_TOUR_INVALID_SHOWING_REQUESTED = 'SrErrorTourInvalidShowingRequested';
export const SR_ERROR_QUESTION_SUBMISSION_ALREADY_EXISTS = 'SrErrorInvalidSubmissionAlreadyExists';
export const SR_ERROR_TOUR_TRANSITION_INVALID_SHOWING_STATUS =
  'SrErrorTourTransitionInvalidShowingStatus';
export const SR_ERROR_ROOMMATE_SIGNUP_IS_ADMIN = 'SrErrorRommateSignupIsAdmin';
export const SR_ERROR_NO_FRONT_CHANNELS_AVAILABLE = 'SrErrorNoFrontChannelsAvailable';
export const SR_ERROR_NO_MORE_FRONT_CHANNELS_AVAILABLE = 'SrErrorNoMoreFrontChannelsAvailable';
export const SR_ERROR_LISTING_NOT_AVAILABLE_TO_VISIT_OFF_HOURS =
  'SrErrorListingNotAvailableToVisitOffHours';
export const SR_PARTNER_SIGNUP_USER_IS_ALREADY_PARTNER_ERROR =
  'SrPartnerSignupUserIsAlreadyPartnerError';

export const SR_STATE_MACHINE_ERROR_ENTITY_NOT_FOUND = 'SrStateMachineErrorEntityNotFound';
export const SR_STATE_MACHINE_ERROR_INVALID_TRANSITION = 'SrStateMachineErrorInvalidTransition';
export const SR_STATE_MACHINE_ERROR_PRE_SAVE_HOOK_FAILED = 'SrStateMachineErrorPreSaveHookFailed';
export const SR_STATE_MACHINE_ERROR_AFTER_SAVE_AFTER_FAILED =
  'SrStateMachineErrorAfterSaveHookFailed';

export const SR_FRONT_ERROR_RESPONSE_NOT_OK = 'SrFrontErrorResponseNotOk';
export const SR_CIRCLECI_ERROR_RESPONSE_NOT_OK = 'SrCircleCiErrorResponseNotOk';
export const SR_FRONT_ERROR_MESSAGE_NOT_ACCEPTED = 'SrFrontErrorMessageNotAccepted';
export const SR_REALSAVVY_ERROR_LISTING_BY_DATA_SOURCE_NOT_FOUND =
  'SrRealSavvyErrorListingByDataSourceNotFound'; // eslint-disable-line max-len
export const SR_ONFLEET_ERROR_RESPONSE_NOT_OK = 'SrOnfleetErrorResponseNotOk';
export const SR_ONFLEET_ERROR_WEBHOOK_INVALID_CONTAINER_TYPE =
  'SrOnfleetErrorWebhookInvalidContainerType';
export const SR_ONFLEET_ERROR_ONFLEET_AGENT_MISSING_SUNROOM_USER =
  'SrOnfleetErrorOnfleetAgentMissingSunroomUser'; // eslint-disable-line max-len
export const SR_SMART_APARTMENT_ERROR_RESPONSE_NOT_OK = 'SrSmartApartmentErrorResponseNotOk';
export const SR_SMART_APARTMENT_ERROR_MISSING_REQUIRED_FIELDS =
  'SrSmartApartmentErrorMissingRequiredFields';
export const SR_SENDGRID_ERROR_RESPONSE_NOT_OK = 'SrSendGridErrorResponseNotOk';
export const SR_WEBMERGE_ERROR_RESPONSE_NOT_OK = 'SrWebmergeErrorResponseNotOk';
export const SR_FIREBASE_CLOUD_MESSAGING_ERROR_RESPONSE_NOT_OK =
  'SrFirebaseCloudMessagingErrorResponseNotOk';
export const SR_AUTHY_ERROR_RESPONSE_NOT_OK = 'SrAuthyErrorResponseNotOk';
export const SR_ALGOLIA_ERROR_RESPONSE_NOT_OK = 'SrAlgoliaErrorResponseNotOk';
export const SR_GOOGLE_MAPS_ERROR_RESPONSE_NOT_OK = 'SrGoogleMapsErrorResponseNotOk';
export const SR_QUICKBOOKS_ERROR_RESPONSE_NOT_OK = 'SrQuickBooksErrorResponseNotOk';
export const SR_HOMEBASE_ERROR_RESPONSE_NOT_OK = 'SrHomebaseErrorResponseNotOk';
export const SR_BITLY_ERROR_RESPONSE_NOT_OK = 'SrBitlyErrorResponseNotOk';
export const SR_VOUCHED_ERROR_RESPONSE_NOT_OK = 'SrVouchedErrorResponseNotOk';
export const SR_TENANT_ALERT_ERROR_RESPONSE_NOT_OK = 'SrTenantAlertErrorResponseNotOk';
export const SR_PARTNER_MISSING_STRIPE_ACCOUNT_ID_ERROR = 'SrPartnerMissingStripeAccountIdError';
export const SR_STRIPE_CARD_ERROR = 'StripeCardError';
export const SR_STRIPE_CARD_INSUFFICIENT_FUNDS = 'SrStripeCardInsufficientFunds';
export const SR_STRIPE_CARD_INVALID_TYPE = 'SrStripeCardInvalidType';
export const SR_STRIPE_CARD_INVALID_CVC = 'SrStripeCardInvalidCVC';
export const SR_STRIPE_CARD_INCORRECT_CVC = 'SrStripeCardIncorrectCVC';
export const SR_STRIPE_CARD_EXPIRED_CARD = 'SrStripeCardExpiredCard';
export const SR_STRIPE_CARD_INCORRECT_NUMBER = 'SrStripeCardIncorrectNumber';
export const SR_STRIPE_CARD_GENERIC_DECLINE_ERROR = 'SrStripeCardGenericDeclineError';
export const SR_SIGN_OTTER_ERROR_RESPONSE_NOT_OK = 'SrSignOtterErrorResponseNotOk';
export const SR_IGLOOHOME_ERROR_RESPONSE_NOT_OK = 'SrIgloohomeErrorResponseNotOk';
export const SR_CODEBOX_ERROR_RESPONSE_NOT_OK = 'SrCodeboxErrorResponseNotOk';
export const SR_CUSTOMER_IO_ERROR_RESPONSE_NOT_OK = 'SrCustomerIoErrorResponseNotOk';
export const SR_CLOSING_DOCS_ERROR_RESPONSE_NOT_OK = 'SrClosingDocsErrorResponseNotOk';
export const SR_VERIFAST_ERROR_RESPONSE_NOT_OK = 'SrVerifastErrorResponseNotOk';
export const SR_FINICITY_ERROR_RESPONSE_NOT_OK = 'SrFinicityErrorResponseNotOk';
export const SR_PINWHEEL_ERROR_RESPONSE_NOT_OK = 'SrPinwheelErrorResponseNotOk';
export const SR_SIGNEASY_ERROR_RESPONSE_NOT_OK = 'SrSignEasyErrorResponseNotOk';
export const SR_PET_SCREENING_ERROR_RESPONSE_NOT_OK = 'SrPetScreeningErrorResponseNotOk';
export const SR_PET_SCREENING_ERROR_INVALID_PASSWORD = 'SrPetScreeningErrorInvalidPassword';
export const SR_AUTOENHANCE_ERROR_RESPONSE_NOT_OK = 'SrAutoEnhanceErrorResponseNotOk';
export const SR_ROUTABLE_ERROR_RESPONSE_NOT_OK = 'SrRoutableErrorResponseNotOk';
export const SR_ROUTABLE_ERROR_NOT_ENABLED = 'SrRoutableErrorNotEnabled';
export const SR_RENTVINE_ERROR_RESPONSE_NOT_OK = 'SrRentvineErrorResponseNotOk';
export const SR_RENT_MANAGER_ERROR_CONNECTION_NOT_OK = 'SrRentManagerErrorConnectionNotOk';
export const SR_UP_API_ERROR_UPSTREAM_UNAVAILABLE = 'SrUpApiErrorUpstreamUnavailable';

export const SR_LEASE_CREATE_DRAFT_PENDING_DOCUMENT_ERROR =
  'SrLeaseCreateDraftPendingDocumentError';
export const SR_LEASE_CREATE_DRAFT_PARTNER_NOT_ENABLED_ERROR =
  'SrLeaseCreateDraftPartnerNotEnabledError';
export const SR_LEASE_VOID_DOCUMENT_ALREADY_VOIDED_ERROR = 'SrLeaseVoidDocumentAlreadyVoidedError';

export const SR_UTILITY_ERROR_ADDRESS_ALREADY_ACTIVATED_SAME_PHONE =
  'SrUtilityErrorAddressAlreadyActivatedSamePhone';
export const SR_UTILITY_ERROR_ADDRESS_ALREADY_ACTIVATED_DIFFERENT_PHONE =
  'SrUtilityErrorAddressAlreadyActivatedDifferentPhone';

export const SR_SENTRY_ERROR_CODES_TO_IGNORE = [
  SR_API_ERROR_NOT_ALLOWED,
  SR_API_ERROR_INVALID_CREDENTIALS,
  SR_ERROR_USER_ALREADY_EXISTS,
];
